var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVerified(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.5301 0.46995C11.3894 0.3295 11.1988 0.25061 11.0001 0.25061C10.8013 0.25061 10.6107 0.3295 10.4701 0.46995L7.69007 3.24995H4.00007C3.80116 3.24995 3.61039 3.32897 3.46974 3.46962C3.32909 3.61027 3.25007 3.80104 3.25007 3.99995V7.68995L0.470073 10.47C0.329622 10.6106 0.250732 10.8012 0.250732 11C0.250732 11.1987 0.329622 11.3893 0.470073 11.53L3.25007 14.31V18C3.25007 18.4139 3.58607 18.75 4.00007 18.75H7.69007L10.4701 21.53C10.6107 21.6704 10.8013 21.7493 11.0001 21.7493C11.1988 21.7493 11.3894 21.6704 11.5301 21.53L14.3101 18.75H18.0001C18.199 18.75 18.3898 18.6709 18.5304 18.5303C18.6711 18.3896 18.7501 18.1989 18.7501 18V14.31L21.5301 11.53C21.6705 11.3893 21.7494 11.1987 21.7494 11C21.7494 10.8012 21.6705 10.6106 21.5301 10.47L18.7501 7.68995V3.99995C18.7501 3.80104 18.6711 3.61027 18.5304 3.46962C18.3898 3.32897 18.199 3.24995 18.0001 3.24995H14.3101L11.5301 0.46995ZM13.4261 8.01795L9.71607 12.433L7.99207 10.934L7.00807 12.066L9.88407 14.566L14.5741 8.98195L13.4261 8.01795Z",
    fill: "#007B8B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerified);
export default __webpack_public_path__ + "static/media/verified.9147345e1b1e28c94c136779a1731d5d.svg";
export { ForwardRef as ReactComponent };